import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , subKeySaga
  , fillDictionary
  , makeReadPayload
  , handleCallback
} from "shared-utility/store/utils/helpers";
import { DEAL_STATUSES } from "@loanbossinc/component-library";
import { ToastSuccess, ToastError, ToastInfo } from "components/Global/Toasts/Toasty";

const initialState = {
  loansByStatus: []
};

// ChangeDealStatusModal
export const CHANGE_DEAL_STATUS_GET_LOANS_BY_DEAL_AND_STATUS = generateDefaultActions("CHANGE_DEAL_STATUS_GET_LOANS_BY_DEAL_AND_STATUS");
export const getLoansByDealIdAndStatus = payload => makePayload(CHANGE_DEAL_STATUS_GET_LOANS_BY_DEAL_AND_STATUS.value, payload);
function clearLoansByDealIdAndStatus(payload, subKey) {
  return {
    type: CHANGE_DEAL_STATUS_GET_LOANS_BY_DEAL_AND_STATUS.success,
    payload,
    subKey
  };
}
function* getLoansByDealIdAndStatusSaga(payload) {
  const { dealId, loanStatusId } = payload;
  try {
    if (!dealId) {
      yield put(clearLoansByDealIdAndStatus({}, loanStatusId));
    } else {
      const url = `/loans/getLoansByDealIdAndStatus/${dealId}/${loanStatusId}`;
      const requestSaga = subKeySaga(loanStatusId);
      yield requestSaga(CHANGE_DEAL_STATUS_GET_LOANS_BY_DEAL_AND_STATUS, url, "GET");
    }
  } catch (error) {
    ToastError("Error Selecting Loans");
  }
}

export const CHANGE_DEAL_STATUS_SET_DEAL_TO_REFINANCE = generateDefaultActions("CHANGE_DEAL_STATUS_SET_DEAL_TO_REFINANCE");
export const setDealToRefinance = payload => makePayload(CHANGE_DEAL_STATUS_SET_DEAL_TO_REFINANCE.value, payload);
function* setDealToRefinanceSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;
  const url = "/deal/setDealToRefinance";
  yield requestSaga(CHANGE_DEAL_STATUS_SET_DEAL_TO_REFINANCE, url, "POST", payload);
  if (callback) {
    callback();
  }
}

export const CHANGE_DEAL_STATUS_ACK_REDIRECT = generateDefaultActions("CHANGE_DEAL_STATUS_ACK_REDIRECT");
export const acknowledgeRedirect = payload => makePayload(CHANGE_DEAL_STATUS_ACK_REDIRECT.value, payload);
function* acknowledgeRedirectSaga() { }
// ChangeDealStatusModal

// SellDealWizardModal
export const CHANGE_DEAL_STATUS_GET_DEAL_TO_SELL = generateDefaultActions("CHANGE_DEAL_STATUS_GET_DEAL_TO_SELL");
export const getDealToSell = dealId => ({ type: CHANGE_DEAL_STATUS_GET_DEAL_TO_SELL.value, dealId });
function* getDealToSellSaga(payload) {
  yield requestSaga(CHANGE_DEAL_STATUS_GET_DEAL_TO_SELL, `/deals/${payload.dealId}/forSelling`);
}

export const CHANGE_DEAL_STATUS_SELL_DEAL = generateDefaultActions("CHANGE_DEAL_STATUS_SELL_DEAL");
export const sellDeal = deal => ({ type: CHANGE_DEAL_STATUS_SELL_DEAL.value, deal });
function* sellDealSaga(payload) {
  const url = `/deal/${payload.deal.id}/sell`;
  yield requestSaga(CHANGE_DEAL_STATUS_SELL_DEAL, url, "POST", payload.deal);
}

export const CHANGE_DEAL_STATUS_RECALCUALTE_DEAL_EXIT_DEBT_YIELD = generateDefaultActions("CHANGE_DEAL_STATUS_RECALCUALTE_DEAL_EXIT_DEBT_YIELD");
export const recalculateDealExitDebtYield = payload => makePayload(CHANGE_DEAL_STATUS_RECALCUALTE_DEAL_EXIT_DEBT_YIELD.value, payload);
function* recalculateDealExitDebtYieldSaga(payload) {
  const url = "/deal/recalculateDealExitDebtYield";
  yield requestSaga(CHANGE_DEAL_STATUS_RECALCUALTE_DEAL_EXIT_DEBT_YIELD, url, "POST", payload);
}

export const CHANGE_DEAL_STATUS_GET_SALES_BROKERS = generateDefaultActions("CHANGE_DEAL_STATUS_GET_SALES_BROKERS");
export const getSalesBrokers = payload => makeReadPayload(CHANGE_DEAL_STATUS_GET_SALES_BROKERS.value, payload);
function* getSalesBrokersSaga() {
  yield requestSaga(CHANGE_DEAL_STATUS_GET_SALES_BROKERS, "/getSalesBrokers");
}

export const CHANGE_DEAL_STATUS_GET_CONTACTS_BY_COMPANY = generateDefaultActions("CHANGE_DEAL_STATUS_GET_CONTACTS_BY_COMPANY");
export const getContactsByCompany = payload => makePayload(CHANGE_DEAL_STATUS_GET_CONTACTS_BY_COMPANY.value, payload);
function* getContactsByCompanySaga(payload) {
  const { companyId } = payload;
  const url = `/contactsByCompany?companyId=${companyId}`;

  yield requestSaga(CHANGE_DEAL_STATUS_GET_CONTACTS_BY_COMPANY, url);
}
// SellDealWizardModal

// ModifyLoansModal
export const CHANGE_DEAL_STATUS_GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS = generateDefaultActions("CHANGE_DEAL_STATUS_GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS");
export const getLoansByPreferenceAndLoanStatus = payload => makePayload(CHANGE_DEAL_STATUS_GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS.value, payload);
function* getLoansByPreferenceAndLoanStatusSaga(payload) {
  const url = "/getLoansByPreference/byStatus";
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.type;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(CHANGE_DEAL_STATUS_GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS, url, "POST", filteredPayload);
}

export const CHANGE_DEAL_STATUS_COMPLETE_LOAN_MODIFICATION = generateDefaultActions("CHANGE_DEAL_STATUS_COMPLETE_LOAN_MODIFICATION");
export const completeLoanModification = (deal, callback) => makePayload(CHANGE_DEAL_STATUS_COMPLETE_LOAN_MODIFICATION.value, { deal, callback });
function* completeLoanModificationSaga(payload) {
  const callback = handleCallback(payload);
  yield requestSaga(CHANGE_DEAL_STATUS_COMPLETE_LOAN_MODIFICATION, "/deal/completeLoanModification", "POST", payload.deal);
  yield callback();
}

export const CHANGE_DEAL_STATUS_GET_DEAL_WITH_LOANS_BEING_MODIFIED = generateDefaultActions("GET_DEAL_FOR_LOAN_MODIFICATION");
export const getDealWithLoansBeingModified = dealId => makePayload(CHANGE_DEAL_STATUS_GET_DEAL_WITH_LOANS_BEING_MODIFIED.value, { dealId });
function* getDealWithLoansBeingModifiedSaga(payload) {
  yield requestSaga(CHANGE_DEAL_STATUS_GET_DEAL_WITH_LOANS_BEING_MODIFIED, `/deal/${payload.dealId}/getDealWithLoansBeingModified`, "GET");
}
// ModifyLoansModal

export function changeDealStatusModalReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case CHANGE_DEAL_STATUS_GET_LOANS_BY_DEAL_AND_STATUS.success:
      return fillDictionary(state, payload, "loansByStatus", subKey);
    case CHANGE_DEAL_STATUS_SET_DEAL_TO_REFINANCE.success:
      return { ...state };
    case CHANGE_DEAL_STATUS_ACK_REDIRECT.value:
      return { ...state };
    case CHANGE_DEAL_STATUS_GET_DEAL_TO_SELL.success:
      return { ...state, dealToSell: payload.result };
    case CHANGE_DEAL_STATUS_SELL_DEAL.success:
      return { ...state, reloadDeal: true };
    case CHANGE_DEAL_STATUS_GET_SALES_BROKERS.success:
      const SALES_BROKERS = "sales_brokers";

      return fillDictionary(state, payload, "enumeratedTypes", SALES_BROKERS);
    case CHANGE_DEAL_STATUS_GET_CONTACTS_BY_COMPANY.success:
      // eslint-disable-next-line no-case-declarations
      const key = Object.keys(payload)[0];

      return fillDictionary(state, payload[key], "contactsByCompany", key);
    case CHANGE_DEAL_STATUS_GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS.success:
      return fillDictionary(state, payload, "loansByPreference", subKey);
    case CHANGE_DEAL_STATUS_COMPLETE_LOAN_MODIFICATION.success:
      if (payload.data.dealStatusId === DEAL_STATUSES.MODIFYING) {
        return { ...state, reloadDeal: true };
      }

      return { ...state, redirectTo: `/deal/${payload.data.id}` };
    case CHANGE_DEAL_STATUS_GET_DEAL_WITH_LOANS_BEING_MODIFIED.success:
      return { ...state, dealWithLoansBeingModified: payload.data };
    default:
      return state;
  }
}

// SAGA
export function* changeDealStatusModalSaga() {
  yield takeLatest(CHANGE_DEAL_STATUS_GET_LOANS_BY_DEAL_AND_STATUS.value, getLoansByDealIdAndStatusSaga);
  yield takeLatest(CHANGE_DEAL_STATUS_SET_DEAL_TO_REFINANCE.value, setDealToRefinanceSaga);
  yield takeLatest(CHANGE_DEAL_STATUS_ACK_REDIRECT.value, acknowledgeRedirectSaga);

  yield takeEvery(CHANGE_DEAL_STATUS_GET_DEAL_TO_SELL.value, getDealToSellSaga);
  yield takeEvery(CHANGE_DEAL_STATUS_SELL_DEAL.value, sellDealSaga);
  yield takeEvery(CHANGE_DEAL_STATUS_RECALCUALTE_DEAL_EXIT_DEBT_YIELD.value, recalculateDealExitDebtYieldSaga);
  yield takeEvery(CHANGE_DEAL_STATUS_GET_SALES_BROKERS.value, getSalesBrokersSaga);
  yield takeEvery(CHANGE_DEAL_STATUS_GET_CONTACTS_BY_COMPANY.value, getContactsByCompanySaga);
  yield takeEvery(CHANGE_DEAL_STATUS_GET_LOANS_BY_PREFERENCE_AND_LOAN_STATUS.value, getLoansByPreferenceAndLoanStatusSaga);
  yield takeLatest(CHANGE_DEAL_STATUS_COMPLETE_LOAN_MODIFICATION.value, completeLoanModificationSaga);
  yield takeLatest(CHANGE_DEAL_STATUS_GET_DEAL_WITH_LOANS_BEING_MODIFIED.value, getDealWithLoansBeingModifiedSaga);
}
